import React from 'react';
import UserSettings from "../Components/UserSettings"

const Settings = () => {
    return <UserSettings />
}

export default Settings